/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable-next-line react/prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */

import React, { useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Dimensions, Platform, TouchableOpacity, View } from 'react-native';
import { launchCamera, launchImageLibrary } from 'react-native-image-picker';
import * as FileSystem from 'expo-file-system';
import * as DocumentPicker from 'expo-document-picker';
import { readAsync } from '@lodev09/react-native-exify';
import { manipulateAsync, SaveFormat } from 'expo-image-manipulator';

import { isAndroid, isIos, isNative, isMobileWeb } from '@global/screens';

import ModalHalf from '@components/modal/ModalHalf';
import Button from '@components/form/Button';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';

import Colors from '@global/colors';
import { uploadS3, savePhotoToGallery } from '@global/helpers';
import { showAlert } from '@/store/global';
import { showPopup } from '@/store/modal';

const dimension = Dimensions.get('screen');
const imageSize = 120;

const imageStyle = {
  width: imageSize,
  height: imageSize,
  borderRadius: 4,
  overflow: 'hidden',
  backgroundColor: '#f7f7f7',
  alignItems: 'center',
  justifyContent: 'center',
};

const ImageUploaderOption = ({
  value = '',
  onChange = () => {},
  disabled = false,
}) => {
  const dispatch = useDispatch();
  // const [, setUploading] = useState(false);
  const [showImageOptions, setShowImageOptions] = useState(false);
  const [image, setImage] = useState(value);

  function resultImage(image) {
    try {
      const fileExtension = image?.uri.split('.').pop() ?? '';
      if (
        fileExtension &&
        /^.*(jpg|jpeg|png).*$/g.test(fileExtension.toLowerCase())
      ) {
        let filename =
          Math.floor(100000000000 * Math.random()) + '-' + Date.now();
        if (fileExtension.toLowerCase().includes('png')) {
          filename = filename + '.png';
          image.type = 'image/png';
        } else {
          filename = filename + '.jpg';
          image.type = 'image/jpeg';
        }
        return {
          uri: image.uri,
          filename,
          type: image.type,
        };
      }
      return false;
    } catch (error) {
      console.log('result-image', error);
      return false;
    }
  }

  async function chooseFromFile() {
    try {
      const supportedMimeTypes = [
        'image/jpeg',
        'image/png',
        'image/webp',
        'image/svg+xml',
      ];
      const res = await DocumentPicker.getDocumentAsync({
        type: supportedMimeTypes,
        copyToCacheDirectory: false,
        multiple: false,
      });
      if (!res.canceled && res.assets?.length > 0) {
        const asset = res.assets[0];

        const isSupported = ['image/jpeg', 'image/png', 'image/webp'].includes(
          asset.mimeType,
        );

        if (!isSupported) {
          dispatch(
            showAlert({
              show: true,
              isModal: true,
              title: 'Invalid file type',
              description: 'Only JPG, PNG, or WEBP files are supported.',
              isConfirm: false,
            }),
          );
          return false;
        }

        const fileExtension = asset.name?.split('.').pop() || '';
        const lowerExt = fileExtension.toLowerCase();

        let mimeType = 'image/jpeg'; // default
        if (lowerExt === 'png') {
          mimeType = 'image/png';
        } else if (lowerExt === 'webp') {
          mimeType = 'image/webp';
        }

        const destPath = `${FileSystem.cacheDirectory}${Date.now()}-${
          asset.name
        }`;

        const finalUri = destPath;
        if (isIos && !asset.uri.startsWith('file://')) {
          await FileSystem.downloadAsync(asset.uri, destPath);
        } else {
          const base64 = await FileSystem.readAsStringAsync(asset.uri, {
            encoding: FileSystem.EncodingType.Base64,
          });
          await FileSystem.writeAsStringAsync(destPath, base64, {
            encoding: FileSystem.EncodingType.Base64,
          });
        }

        const image = {
          uri: finalUri,
          filename: asset.name,
          type: mimeType,
        };

        return resultImage(image);
      }

      return false;
    } catch (error) {
      console.log('chooseFromFile error', error);
      return false;
    }
  }

  const requestCameraPermission = async () => {
    try {
      if (isAndroid) {
        const PermissionsAndroid =
          Platform.OS === 'android'
            ? require('react-native').PermissionsAndroid
            : null;
        const granted = await PermissionsAndroid?.request(
          PermissionsAndroid.PERMISSIONS.CAMERA,
          {
            title: 'App Camera Permission',
            message: 'App needs access to your camera',
            buttonNeutral: 'Ask Me Later',
            buttonNegative: 'Cancel',
            buttonPositive: 'OK',
          },
        );
        if (granted === PermissionsAndroid.RESULTS.GRANTED) {
          return true;
        } else {
          console.log('Camera permission denied');
          dispatch(
            showAlert({
              show: true,
              isModal: true,
              title: 'Permission denied',
              description: 'You need to give permission to access your camera',
              isConfirm: false,
            }),
          );
          return false;
        }
      } else if (isIos) {
        return true;
      }
    } catch (err) {
      console.warn(err);
      return false;
    }
  };

  async function manipulateImage({ image }) {
    const MAX_IMAGE_SIZE = 1 * 1024 * 1024;

    try {
      const isPortrait = image.height >= image.width;
      const FIXED_WIDTH_PORTRAIT = 1080;
      const FIXED_WIDTH_LANDSCAPE = 1920;

      const targetWidth = isPortrait
        ? FIXED_WIDTH_PORTRAIT
        : FIXED_WIDTH_LANDSCAPE;
      const targetHeight = Math.round(
        targetWidth * (image.height / image.width),
      );

      let normalized;

      if (isAndroid) {
        normalized = await manipulateAsync(
          image.uri,
          [
            {
              resize: {
                width: targetWidth,
                height: targetHeight,
              },
            },
          ],
          {
            compress: 1,
            format: SaveFormat.JPEG,
          },
        );
      } else {
        normalized = await manipulateAsync(image.uri, [], {
          compress: 1,
          format: SaveFormat.JPEG,
        });
      }

      let compressLevel = 1;
      let result = normalized;
      let fileInfo = await FileSystem.getInfoAsync(result.uri);

      while (fileInfo.size > MAX_IMAGE_SIZE && compressLevel > 0.85) {
        compressLevel -= 0.05;

        result = await manipulateAsync(result.uri, [], {
          compress: compressLevel,
          format: SaveFormat.JPEG,
        });

        fileInfo = await FileSystem.getInfoAsync(result.uri);
      }

      return {
        ...image,
        uri: result.uri,
        width: result.width,
        height: result.height,
      };
    } catch (error) {
      console.log('manipulateImage error:', error);
      return image;
    }
  }

  async function takePicture() {
    try {
      const options = {
        saveToPhotos: false,
        mediaType: 'photo',
        includeBase64: false,
        quality: 1,
        includeExtra: true,
        ...(isAndroid
          ? {
              skipBackup: true,
              path: 'images',
              cameraRoll: true,
              waitUntilSaved: true,
            }
          : {}),
      };

      const isPermit = await requestCameraPermission();

      if (isPermit) {
        return new Promise((resolve) => {
          setTimeout(async () => {
            try {
              const res = await launchCameraAsync(options);

              if (res?.assets?.[0]) {
                const captured = res.assets[0];

                if (isAndroid) {
                  try {
                    const tags = await readAsync(captured.uri);
                    if (tags?.Orientation == 6 || tags?.Orientation == 8) {
                      const tempWidth = captured.width;
                      const tempHeight = captured.height;
                      captured.width = tempHeight;
                      captured.height = tempWidth;
                    }
                  } catch (error) {
                    console.log('error when handle rotation', error);
                  }
                }

                const finalUri = await manipulateImage({
                  image: captured,
                });
                // [B2B-5968] Save the camera shot to the gallery when Auto-save photos is on.
                savePhotoToGallery(finalUri?.uri);

                const result = resultImage(finalUri);
                resolve(result);
              } else {
                console.log('No image captured');
                resolve({});
              }
            } catch (error) {
              console.log('Error during camera launch or processing', error);
              resolve({});
            }
          }, 500);
        });
      } else {
        console.log('Permission denied');
        dispatch(
          showAlert({
            show: true,
            isModal: true,
            title: 'Permission denied',
            description: 'You need to give permission to access your camera',
            isConfirm: false,
          }),
        );
        return {};
      }
    } catch (error) {
      console.log('takePicture error', error);
      return {};
    }
  }

  async function launchCameraAsync(options) {
    return new Promise((resolve, reject) => {
      launchCamera(options, (res) => {
        if (res.didCancel) {
          resolve({ didCancel: true });
        } else if (res.errorCode) {
          reject(new Error(`ImagePicker Error: ${res.errorMessage}`));
        } else {
          resolve(res);
        }
      });
    });
  }

  async function chooseImagePicker() {
    try {
      const options = {
        mediaType: 'photo',
      };

      const result = await new Promise((resolve) =>
        launchImageLibrary(options, (response) => resolve(response)),
      );

      if (result && result.assets && result.assets.length > 0) {
        const picked = result.assets[0];

        if (isAndroid) {
          try {
            const tags = await readAsync(picked.uri);
            if (tags?.Orientation == 6 || tags?.Orientation == 8) {
              const tempWidth = picked.width;
              const tempHeight = picked.height;
              picked.width = tempHeight;
              picked.height = tempWidth;
            }
          } catch (error) {
            console.log('error when handle rotation', error);
          }
        }

        const finalUri = await manipulateImage({
          image: picked,
        });

        return resultImage(finalUri);
      }
      return false;
    } catch (error) {
      console.log('chooseImagePicker error', error);
      return false;
    }
  }
  const handleProcess = async (image) => {
    if (image && image.uri) {
      try {
        // setUploading(true);
        dispatch(showPopup({ name: 'isLoading', value: true }));

        const url = await uploadS3({ file: image, isImage: true });
        dispatch(showPopup({ name: 'isLoading', value: false }));

        if (url) {
          setImage(url);
          onChange(url);
        } else {
          dispatch(
            showAlert({
              show: true,
              isModal: true,
              title: 'Error',
              description: 'Failed to upload image',
              isConfirm: false,
            }),
          );
        }
      } catch (err) {
        console.log('err', err);
        dispatch(showPopup({ name: 'isLoading', value: false }));
        dispatch(
          showAlert({
            show: true,
            isModal: true,
            title: 'Error',
            description: 'Failed to upload image',
            isConfirm: false,
          }),
        );
      } finally {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        // setUploading(false);
      }
    }
  };

  const pickImage = async (source = 'camera') => {
    if (disabled) {
      return;
    }

    setShowImageOptions(false);
    await new Promise((resolve) => setTimeout(resolve, 300));

    let image;
    if (source === 'camera') {
      image = await takePicture();
    } else if (source === 'gallery') {
      image = await chooseImagePicker();
    } else if (source === 'file') {
      if (!isNative) {
        image = await chooseImagePicker();
      } else {
        image = await chooseFromFile();
      }
    }

    await handleProcess(image);
  };

  const displayImage = useMemo(() => {
    return (
      <Image
        style={{ width: 25, height: 25, resizeMode: 'contain' }}
        width={25}
        height={25}
        svg
        source={require('@assets/img/icons/add-photo.svg')}
        resizeMode="contain"
      />
    );
  }, [image]);

  return (
    <>
      <TouchableOpacity
        onPress={() => {
          if (!disabled) {
            !isMobileWeb ? setShowImageOptions(true) : pickImage('file');
          }
        }}
        activeOpacity={0.6}
        style={[imageStyle, disabled && { opacity: 0.5 }]}>
        {displayImage}
      </TouchableOpacity>

      <ModalHalf
        title=""
        visible={showImageOptions}
        maxWidth="100%"
        spaceFromTop={false}
        onClose={() => setShowImageOptions(false)}>
        <View
          style={{
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Button
            type="grey"
            rounded
            buttonStyle={{ width: dimension.width - 40, marginVertical: 5 }}
            title={
              <SociollaText
                type="bold"
                style={{ fontSize: 14, color: Colors.blue10 }}>
                Take photo
              </SociollaText>
            }
            onPress={() => pickImage('camera')}
          />
          <Button
            type="grey"
            rounded
            buttonStyle={{ width: dimension.width - 40, marginVertical: 5 }}
            title={
              <SociollaText
                type="bold"
                style={{ fontSize: 14, color: Colors.blue10 }}>
                Choose from gallery
              </SociollaText>
            }
            onPress={() => pickImage('gallery')}
          />
          <Button
            type="grey"
            rounded
            buttonStyle={{ width: dimension.width - 40, marginVertical: 5 }}
            title={
              <SociollaText
                type="bold"
                style={{ fontSize: 14, color: Colors.blue10 }}>
                Choose from file
              </SociollaText>
            }
            onPress={() => pickImage('file')}
          />
          <View
            style={{
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 15,
              paddingTop: 15,
              borderTopColor: Colors.grey0,
              borderTopWidth: 1,
            }}>
            <Button
              type="grey"
              rounded
              buttonStyle={{ width: dimension.width - 40 }}
              title={
                <SociollaText
                  type="bold"
                  style={{ fontSize: 14, color: Colors.red1 }}>
                  Cancel
                </SociollaText>
              }
              onPress={() => setShowImageOptions(false)}
            />
          </View>
        </View>
      </ModalHalf>
    </>
  );
};

export default React.memo(ImageUploaderOption, (prev, next) => prev === next);
